<div class="card card-shadow">
    <div class="card-header bp-card-header">
        <i class="fas fa-envelope-open fa-small fa-current-bill"></i>
        <p class="font-weight-light bp-text">Your Current Bill</p>
    </div>
    <div class="card-body">
        <div class="row current-bill-text">
            <div class="col-sm-6 no-left-padding">
                <p class="font-weight-light bp-text bp-medium-big-text">Draft Date <b>{{ utility.formatDate(currentBill.draftDate) }}</b></p>
                <p class="bp-text">Billing Period <b>{{ utility.formatDate(currentBill.periodStartDate) + '-' + utility.formatDate(currentBill.periodEndDate) }}</b></p>
                <h4><a class="current-bill-footer"><a class="bp-link-blue" routerLink="/Billing/BillHistory">Billing & Payment History</a></a></h4>
            </div>
            <div class="col-sm-6">
                <p class="text-right bp-text">Total Due</p>
                <p class="text-right bp-big-text"><b>{{ utility.formatCurrency(currentBill.total) }}</b></p>
                <p class="text-right bp-text">Total due reflects pending payments</p>
                <h4 class="text-right"><a class="current-bill-footer" routerLink="/Billing/PayBill/Setup">Pay Your Other Bills</a></h4>
            </div>
        </div>
    </div>
    <footer class="blockquote-footer">
        <div class="row current-bill-footer-row">
            <div class="col-sm-2">
                <div class="card footer-card">
                    <div class="card-body">
                      <img class="current-bill-image" src="assets/bill.jpg" />
                    </div>
                    <footer class="blockquote-footer">
                      <h4><a class="current-bill-footer bill-image-margin">View Bill</a></h4>
                    </footer>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="card footer-card">
                    <div class="card-body">
                      <img style="margin-left: 0.9rem;" class="newsletter-image" src="assets/newsletter.jpg" />
                    </div>
                    <footer class="blockquote-footer current-bill-footer">
                      <h4><a class="current-bill-footer newsletter-margin">View Newsletter</a></h4>
                    </footer>
                </div>
            </div>
            <div class="col-sm-7">
                <div style="height: 3rem;" class="row current-bill-table-margin">
                    <div class="col-sm-6"></div>
                    <div class="col-sm-2 bp-text text-right current-bill-wide-column">1 Year Ago</div>
                    <div class="col-sm-2 bp-text text-right current-bill-wide-column">Last Month</div>
                    <div class="col-sm-2 bp-text text-right current-bill-wide-column">This Month</div>
                </div>
                <div style="" class="row current-bill-table-margin">
                  <div class="col-sm-6 bp-text text-right">Total {{consumptionType}} Used</div>
                    <div class="col-sm-2 bp-text text-right current-bill-wide-column">{{ currentBill.totalPGHUsed1Year }}</div>
                    <div class="col-sm-2 bp-text text-right current-bill-wide-column">{{ currentBill.totalGPHUsedLastMonth }}</div>
                    <div class="col-sm-2 bp-text text-right current-bill-wide-column">{{ currentBill.totalGPHUsedThisMonth }}</div>
                </div>
                <div style="height: 3rem;" class="row current-bill-table-margin">
                    <div class="col-sm-6 bp-text text-right">Average Daily Cost</div>
                    <div class="col-sm-2 bp-text text-right current-bill-wide-column">{{ currentBill.AverageDailyCost1Year }}</div>
                    <div class="col-sm-2 bp-text text-right current-bill-wide-column">{{ currentBill.AverageDailyCostLastMonth }}</div>
                    <div class="col-sm-2 bp-text text-right current-bill-wide-column">{{ currentBill.AverageDailyCostThisMonth }}</div>
                </div>
                <div style="height: 3rem;" class="row current-bill-table-margin">
                    <div class="col-sm-6 bp-text text-right">Days in Billing Period</div>
                    <div class="col-sm-2 bp-text text-right current-bill-wide-column">{{ currentBill.DaysInBillingPeriod1Year }}</div>
                    <div class="col-sm-2 bp-text text-right current-bill-wide-column">{{ currentBill.DaysInBillingPeriodLastMonth }}</div>
                    <div class="col-sm-2 bp-text text-right current-bill-wide-column">{{ currentBill.DaysInBillingPeriodThisMonth }}</div>
                </div>
            </div>
        </div>
    </footer>
</div>



// WEBPACK FOOTER //
// ./src/app/current-bill/current-bill.component.html